/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Sale<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Sale
   * @name GetDataCreate
   * @request POST:/Sale/GetData
   * @secure
   */
  getDataCreate = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Sale/GetData`,
      method: "POST",
      secure: true,
      ...params,
    });
}
